module.exports = __webpack_public_path__ + "static/img/fish32.4ff752f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish32.png
// module id = p23W
// module chunks = 0